import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import PreClearanceTable from '@app/components/apps/Import/ImportTable';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useLocation, useNavigate } from 'react-router-dom';
import ImportTable from '@app/components/apps/Import/ImportTable';
import { getAllImports } from '@app/api/import.api';

const breadcrumbMap: Record<string, string> = {
  NORMAL: 'Normal',
  NON_COMPLIANCE_1: 'Non-Compliance 1',
  NON_COMPLIANCE_3: 'Non-Compliance 3',
  NO_OBJECTION: 'No Objection',
  NON_RELEVANT: 'Non-Relevant',
};

const AllImport: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.replace('/', '');

  const [importType, setImportType] = useState('NORMAL');
  const breadcrumbName = breadcrumbMap[importType] || 'Imports';

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userType = user?.usertype;

  const isAdminRestricted =
    userType === 'ADMIN' && importType !== 'NON_COMPLIANCE_1' && importType !== 'NON_COMPLIANCE_3';

  const isCustomerRestricted =
    userType === 'CUSTOMER' && (importType === 'NON_COMPLIANCE_1' || importType === 'NON_COMPLIANCE_3');

  const isCreateDisabled = isAdminRestricted || isCustomerRestricted;

  useEffect(() => {
    setImportType(localStorage.getItem('selected_import_type') || 'NORMAL');
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: `/${currentPath}`, breadcrumbName: `Imports - ${breadcrumbName}` }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    clearHeaderButtons();

    if (!isCreateDisabled) {
      addHeaderButton(
        'Add Task',
        <BaseButton type="primary" size="small" onClick={() => navigate('/add-import')}>
          Create
        </BaseButton>,
      );
    }

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [importType, setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate, isCreateDisabled]);

  return (
    <>
      <PageTitle>Import</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ImportTable />
        </Col>
      </Row>
    </>
  );
};

export default AllImport;
